import { useEffect, useState } from "react";
const measure = (range) => {
    const list = range.getClientRects();
    const out = [];
    for (let i = 0; i < list.length; i += 1) {
        const r = list[i];
        if (r)
            out.push(r);
    }
    return out;
};
export const useRangeRects = (range) => {
    const [rects, setRects] = useState(() => range ? measure(range) : []);
    useEffect(() => {
        if (!range) {
            setRects([]);
            return;
        }
        let frame = 0;
        const schedule = () => {
            if (frame !== 0)
                return;
            frame = requestAnimationFrame(() => {
                frame = 0;
                setRects(measure(range));
            });
        };
        schedule();
        window.addEventListener("scroll", schedule, {
            passive: true,
            capture: true,
        });
        window.addEventListener("resize", schedule, { passive: true });
        document.addEventListener("selectionchange", schedule);
        return () => {
            if (frame !== 0)
                cancelAnimationFrame(frame);
            window.removeEventListener("scroll", schedule, {
                capture: true,
            });
            window.removeEventListener("resize", schedule);
            document.removeEventListener("selectionchange", schedule);
        };
    }, [range]);
    return rects;
};
//# sourceMappingURL=useRangeRect.js.map